import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import { initiateUpgrade, fetchService } from '../../actions/service'
import { createBillingCustomerSession, fetchBilling, fetchPreviewInvoice } from '../../actions/billing'
import UpgradePaymentPage from '../../components/upgrade/UpgradePaymentPage'
import UpgradeSuccessPage from '../../components/upgrade/UpgradeSuccessPage'

const urlSearchParams = (location) => qs.parse(location.search.slice(1))

class UpgradePaymentContainer extends Component {
  constructor(props) {
    super(props)
    this.setCustomerSessionClientSecretIfNeeded = this.setCustomerSessionClientSecretIfNeeded.bind(this)

    const upgradeSuccessful = urlSearchParams(props.location).redirect_status === 'succeeded'
    this.state = {
      upgradeSuccessful,
      upgradeError: null,
      customerSessionClientSecret: null,
      hasSetCustomerSessionClientSecretCalled: false,
    }
  }

  componentDidMount() {
    this.setCustomerSessionClientSecretIfNeeded()
  }

  componentDidUpdate(prevProps) {
    const { service } = this.props
    if (prevProps.service !== service) {
      this.setCustomerSessionClientSecretIfNeeded()
    }
  }

  async setCustomerSessionClientSecretIfNeeded() {
    const { upgradeSuccessful, hasSetCustomerSessionClientSecretCalled } = this.state
    const { service, createBillingCustomerSession } = this.props

    if (hasSetCustomerSessionClientSecretCalled) return
    if (!service) return // service is not loaded yet

    if (!upgradeSuccessful && service.customerId) {
      const session = await createBillingCustomerSession()
      this.setState({ customerSessionClientSecret: session.client_secret })
    }
    this.setState({ hasSetCustomerSessionClientSecretCalled: true })
  }

  render() {
    const { upgradeSuccessful, customerSessionClientSecret } = this.state
    const {
      user, service, isDiscountPeriod, initiateUpgrade,
    } = this.props
    const email = user?.email || ''

    if (upgradeSuccessful) {
      return (
        <UpgradeSuccessPage
          isOnTrial={service?.status === 'trial'}
          hideModal={this.props.hideModal}
          service={service}
          fetchService={this.props.fetchService}
          fetchBilling={this.props.fetchBilling}
          fetchPreviewInvoice={this.props.fetchPreviewInvoice}
        />
      )
    }

    return (
      <UpgradePaymentPage
        trialUsed={this.props.trialUsed}
        initiateUpgrade={initiateUpgrade}
        customerSessionClientSecret={customerSessionClientSecret}
        email={email}
        hideModal={this.props.hideModal}
        upgradeError={this.state.upgradeError}
        setUpgradeError={(upgradeError) => this.setState({ upgradeError })}
        isDiscountPeriod={isDiscountPeriod}
      />
    )
  }
}

export default withRouter(connect(
  (state) => ({
    user: state.user,
    service: state.service,
  }),
  {
    initiateUpgrade,
    createBillingCustomerSession,
    fetchService,
    fetchBilling,
    fetchPreviewInvoice,
  },
)(UpgradePaymentContainer))
